/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_RegionInputs */

const en_add_region = /** @type {(inputs: Add_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Region`)
};

const es_add_region = /** @type {(inputs: Add_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar region`)
};

/**
* | output |
* | --- |
* | "Add Region" |
*
* @param {Add_RegionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const add_region = /** @type {((inputs?: Add_RegionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_RegionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_region(inputs)
	return es_add_region(inputs)
});